import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    description: 'Placeholder text for Orders awaiting shipment',
    defaultMessage: 'You have no orders in Awaiting Shipment',
    id: 'WLb6PA',
  },
  createOrderButton: {
    description: 'button text to create an order',
    defaultMessage: 'Create an Order',
    id: '9DRa+v',
  },
  connectStoreButton: {
    description: 'button text to connect a store',
    defaultMessage: 'Connect a Store',
    id: 'ymqUre',
  },
  importCSV: {
    description: 'button text to import a CSV file',
    defaultMessage: 'Import CSV',
    id: 'LAch/o',
  },
  setUpAutomations: {
    description: 'button text to set up automation rules',
    defaultMessage: 'Set Up Automations',
    id: 'wr+V1m',
  },
  noStoreConnectionCallToAction: {
    description: 'placeholder call to action for users without a store connected yet',
    defaultMessage: 'Connect your store or create an order to get started.',
    id: 'ZLrN0X',
  },
  callToAction: {
    description: 'placeholder call to action for users with a store connected',
    defaultMessage: 'Click the import icon ({icon}) to import orders or <a>set your stores to auto-import</a> while you are away.',
    id: '1yeMc4',
  },
  awaitingShipmentTitle: {
    description: 'placeholder title text for awaiting shipment experiment',
    defaultMessage: 'Welcome to ShipStation',
    id: 'TXOCWV',
  },
  getStarted: {
    description: 'placeholder subtitle text for awaiting shipment experiment explaining how to get started with ShipStation',
    defaultMessage: "To get started, let's import your orders to streamline your fulfillment process.",
    id: 'AHO8s8',
  },
  notReadyToAddOrders: {
    description:
      'placeholder subtitle text for awaiting shipment experiment explaining how to see rates or connect your own carrier account',
    defaultMessage: 'Not ready to add orders? {firstLink} or <carrierLink>connect your own carrier account</carrierLink>',
    id: 'yG99lq',
  },
  seeOurRates: {
    description: 'link text to see our rates on the awaiting shipment placeholder',
    defaultMessage: 'See our rates',
    id: 'OO8LhX',
  },
  enableShipStationCarriers: {
    description: 'link text to enable ShipStation carriers on the awaiting shipment placeholder',
    defaultMessage: 'Enable ShipStation Carriers',
    id: 'yZLg8d',
  },
  emptyBox: {
    description: 'empty box image alt text',
    defaultMessage: 'empty box',
    id: 'E/zXd7',
  },
  contactAdmin: {
    description: 'Tooltip text asking to contact admin for permissions',
    defaultMessage: 'Please contact your admin to access this setting',
    id: 'rb/kCU',
  },
  takeATour: {
    description: 'button to open the demo drawer',
    defaultMessage: 'Explore a Demo',
    id: 'wybdq2',
  },
  inDemoStoreTitle: {
    description: 'Title for demo store placeholder',
    defaultMessage: 'Welcome to your Demo Store!',
    id: 'QfZtxt',
  },
  inDemoStoreDescription: {
    description: 'Description for demo store placeholder',
    defaultMessage:
      'In the Demo Store, you can create a "demo" order to explore and try out our features without affecting your actual orders or using your account balances. The demo order includes tips and tutorials to help you get started.',
    id: 'yDfe4j',
  },
  inDemoStoreTryItOut: {
    description: 'Second line Description for demo store placeholder',
    defaultMessage: 'Create a demo order to try it out!',
    id: 'onD+tJ',
  },
  deactivateDemoStore: {
    description: 'Button text to deactivate demo store',
    defaultMessage: 'Deactivate Demo Store',
    id: 'I0n3Fq',
  },
  openDemoOrder: {
    description: 'Button text to open exisitng demo order',
    defaultMessage: 'Open Demo Order',
    id: 'DKsy8i',
  },
});
